import { useContext } from 'react';

import { CreditContext } from '../index';
import { ICreditInitialState } from '../reducer';

export const useContextSelector = <T>(selector: (state: ICreditInitialState) => T) => {
    const { state } = useContext(CreditContext);

    return selector(state);
};
